import { render, staticRenderFns } from "./ModificarVisita.vue?vue&type=template&id=66a9f671&scoped=true&"
import script from "./ModificarVisita.vue?vue&type=script&lang=js&"
export * from "./ModificarVisita.vue?vue&type=script&lang=js&"
import style0 from "./ModificarVisita.vue?vue&type=style&index=0&id=66a9f671&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66a9f671",
  null
  
)

export default component.exports